import { getFlippingInstance } from './instanceFlipping';

export interface CustomerInfo {
  userId?: string;
  email?: string;
  name?: string;
  phone?: string;
  city?: string;
  practiceName?: string;
}

export interface BookInfo {
  access: string;
  title?: string;
  description?: string;
  type?: string;
  downloadable?: boolean;
  showDetectedLinks?: boolean;
}

export interface FlippingBook {
  bookId: string;
  status: 'UPLOADED' | 'CONVERTING' | 'READY' | 'FAILED';
  info: BookInfo;
  customer?: CustomerInfo;
  pageCount?: number;
  fileSizeBytes?: number;
  createdAt: string;
  updatedAt: string;
}

export interface PDFReplacementRecord {
  replacedAt: string;
  replacedBy: string;
  oldFileSize: number;
  newFileSize: number;
  reason?: string;
}

export interface FlippingBookDetail extends FlippingBook {
  inputS3Key: string;
  pdfUrl: string;
  coverUrl?: string;
  pdfReplacements?: PDFReplacementRecord[];
}

export interface SearchBooksResponse {
  books: FlippingBook[];
  total: number;
  limit: number;
  offset: number;
}

export interface ReplacePDFResponse {
  bookId: string;
  status: string;
  message: string;
  previousFileSize: number;
  newFileSize: number;
}

export const searchBooks = async (params: {
  q?: string;
  status?: string;
  limit?: number;
  offset?: number;
}): Promise<SearchBooksResponse> => {
  const instance = getFlippingInstance();
  const response = await instance.get('/v1/admin/books', { params });
  return response.data;
};

export const getBook = async (bookId: string): Promise<FlippingBookDetail> => {
  const instance = getFlippingInstance();
  const response = await instance.get(`/v1/admin/books/${bookId}`);
  return response.data;
};

export const downloadPDF = async (bookId: string): Promise<Blob> => {
  const instance = getFlippingInstance();
  const response = await instance.get(`/v1/admin/books/${bookId}/download`, {
    responseType: 'blob',
  });
  return response.data;
};

export const replacePDF = async (
  bookId: string,
  file: File,
  operatorEmail: string,
  reason?: string,
): Promise<ReplacePDFResponse> => {
  const instance = getFlippingInstance();
  const formData = new FormData();
  formData.append('file', file);
  if (reason) formData.append('reason', reason);

  const response = await instance.post(
    `/v1/admin/books/${bookId}/replace`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-Admin-Identity': operatorEmail,
      },
    },
  );
  return response.data;
};
